import { z } from 'zod';

const day = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
const money = z.number().finite();
export const PILLARS = ['Bolsa', 'Materias primas', 'Criptomonedas'] as const;
export const OP_NAMES = ['buy', 'buyMore', 'schedBuy', 'short', 'addShort', 'sell', 'schedSell', 'cover', 'schedCover'] as const;

/** POST /api/orders. `key` is generated by the client each time the form opens (prototype: 'k' + Date.now() + Math.random()). */
export const PlaceOrderBody = z.object({
  sym: z.string().min(1).max(40),
  op: z.enum(OP_NAMES),
  amount: money.nullish(), units: money.nullish(),
  trig: z.enum(['price', 'date']).optional(), target: money.nullish(), deadline: day.nullish(),
  note: z.string().max(500).optional(), pillar: z.enum(PILLARS).optional(),
  key: z.string().min(1).max(100),
}).strict();
export type PlaceOrderBody = z.infer<typeof PlaceOrderBody>;

/** PATCH /api/orders/:id — scheduled orders only. */
export const EditOrderBody = z.object({
  amount: money.nullish(), units: money.nullish(),
  trig: z.enum(['price', 'date']).optional(), target: money.nullish(), deadline: day.nullish(),
  note: z.string().max(500).optional(),
}).strict();
export type EditOrderBody = z.infer<typeof EditOrderBody>;

/** PUT /api/pillars/:sym */
export const ChangePillarBody = z.object({ pillar: z.enum(PILLARS) }).strict();
export type ChangePillarBody = z.infer<typeof ChangePillarBody>;

/** GET /api/assets */
export const AssetsQuery = z.object({ pillar: z.enum(PILLARS), q: z.string().max(100).default(''), mkt: z.string().max(60).default(''), cursor: z.string().max(500).optional() });
export type AssetsQuery = z.infer<typeof AssetsQuery>;
/** POST /api/assets/prices: the rows on screen (at most 30). */
export const PricesBody = z.object({ syms: z.array(z.string().min(1).max(40)).min(1).max(30) });
export type PricesBody = z.infer<typeof PricesBody>;
